export default "__VITE_ASSET__2462884e__"